import React, { useRef } from 'react';
import { FaWhatsapp, FaLinkedin } from 'react-icons/fa';
import { MdMailOutline } from 'react-icons/md';
import './Contact.css';
import emailjs from 'emailjs-com';

const Contact = ({ t }) => {
  const formRef = useRef();

  const handleEmail = (e) => {
    e.preventDefault();

    emailjs.sendForm('service_rdf9eu8', 'template_ht9ftht', formRef.current, 'tLbAoJynK-NJ37wVQ');

    e.target.reset();
  };

  return (
    <section id='contact'>
      <h5>{t("contact-title")}</h5>
      <h2>{t("contact-subtitle")}</h2>

      <div className="container contact__container">
        <div className="contact__options">

          <article className="contact__option">
            <MdMailOutline className='contact__option-icon'/>
            <h4>Email</h4>
            <h5>dev.rafaelpermec
              <br />
              @gmail.com</h5>
            <a 
              href="mailto:dev.rafaelpermec@gmail.com" 
              target='_blank' rel="noreferrer"
            >
            {t("contact-email-btn")}
            </a>
          </article>
          <article className="contact__option">
            <FaWhatsapp className='contact__option-icon'/>
            <h4>Whatsapp</h4>
            <h5>+55 (31) 98774-8874</h5>
            <a 
              href="https://api.whatsapp.com/send/?phone=5531987748874&text=Olá, Rafael! Gostaria de conversar com você sobre trabalhos na area de...&type=phone_number" 
              target='_blank' 
              rel="noreferrer"
            >
              {t("contact-message-btn")}
              </a>
          </article>
          <article className="contact__option">
            <FaLinkedin className='contact__option-icon'/>
            <h4>Linkedin</h4>
            <h5>{t("contact-linkedin-subtitle")}</h5>
            <a 
              href="https://www.linkedin.com/in/rafael-permec" 
              target='_blank' 
              rel="noreferrer"
            >
              {t("contact-message-btn")}
            </a>
          </article>

        </div>

        {/* FORM */}
        <form 
          ref={ formRef } 
          onSubmit={ handleEmail }
        >
          <input 
            type="text" 
            name='name' 
            placeholder={t("contact-form-placeholder-name")}
            required 
          />
          <input 
            type="email" 
            name='email' 
            placeholder={t("contact-form-placeholder-email")}
            required 
          />
          <textarea 
            name="message" 
            rows="16" 
            placeholder={t("contact-form-placeholder-message")}
            required></textarea>
          <button 
            type="submit" 
            className="btn btn-primary"
          >
            {t("contact-form-btn")}
          </button>
        </form>
      </div>

    </section>
  )
}

export default Contact;
